/**
 * Lenis Smooth Scroll with GSAP ScrollTrigger Integration
 */
(function () {
  'use strict';

  function initLenis() {
    if (typeof Lenis === 'undefined') {
      console.error('Lenis library not loaded');
      return;
    }

    // Check if GSAP is available for proper integration
    var hasGsap = typeof gsap !== 'undefined';
    var hasScrollTrigger = hasGsap && typeof ScrollTrigger !== 'undefined';

    // Initialize Lenis with autoRaf disabled when using GSAP ticker
    const lenis = new Lenis({
      autoRaf: !hasGsap, // Disable auto RAF when GSAP is available (we'll use gsap.ticker)
      duration: 1.2,
      easing: function (t) {
        return Math.min(1, 1.001 - Math.pow(2, -10 * t));
      },
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 2,
    });

    // Expose globally
    window.lenis = lenis;

    // Integrate with GSAP ticker for synchronized animations
    if (hasGsap) {
      // Use GSAP's ticker instead of own RAF loop for proper sync with ScrollTrigger
      gsap.ticker.add(function (time) {
        lenis.raf(time * 1000);
      });

      // Disable lag smoothing for smoother scroll experience
      gsap.ticker.lagSmoothing(0);

      // Sync with ScrollTrigger if available
      if (hasScrollTrigger) {
        lenis.on('scroll', ScrollTrigger.update);

        // Refresh ScrollTrigger after a frame to ensure all positions are calculated correctly
        requestAnimationFrame(function () {
          ScrollTrigger.refresh();
        });
      }
    } else {
      // Fallback: own RAF loop when GSAP is not available
      function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
      }
      requestAnimationFrame(raf);
    }

    // Pause smooth scroll when modals/drawers are open
    function checkOverlays() {
      var hasOpen = document.querySelector('dialog[open], [popover]:popover-open');
      if (hasOpen) {
        lenis.stop();
      } else {
        lenis.start();
      }
    }

    document.addEventListener('toggle', checkOverlays, true);

    var observer = new MutationObserver(checkOverlays);
    document.querySelectorAll('dialog').forEach(function (el) {
      observer.observe(el, { attributes: true, attributeFilter: ['open'] });
    });

    // Dispatch event so other scripts know Lenis is ready
    window.dispatchEvent(new CustomEvent('lenis:ready'));
  }

  // Wait for everything to be ready: DOM, fonts, and a small settling delay
  function init() {
    // Wait for fonts first
    var fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();

    fontsReady.then(function () {
      // Small delay to let layout fully settle after fonts load
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          initLenis();
        });
      });
    });
  }

  // Start after window load
  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init);
  }
})();

